import { Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import {
  MilestoneBlocked,
  MilestoneCompleted,
  MilestoneInProgress,
  MilestoneTodo,
} from 'components/atoms/icons';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { status } from 'components/organisms/projects/project-list/constants';
import { useTranslation } from 'hooks/use-translation';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-bottom: -2px;
    margin-left: 4px;
  }
`;

const Label = styled.p`
  margin-bottom: 0px;
  font-size: 12px;
`;

export const PDFLegend = () => {
  const taskCompleted = status[3];
  const taskTodo = status[1];
  const taskInProgress = status[2];
  const taskBlocked = status[4];

  const taskTodoLabel = taskTodo.label;
  const taskCompletedLabel = taskCompleted.label;
  const taskInProgressLabel = taskInProgress.label;
  const taskBlockedLabel = taskBlocked.label;

  const milestoneTodoLabel = taskTodo.label;
  const milestoneCompletedLabel = taskCompleted.label;
  const milestoneInProgressLabel = taskInProgress.label;
  const milestoneBlockedLabel = taskBlocked.label;

  const taskLabel = useTranslation('task');
  const milestoneLabel = useTranslation('milestones');

  return (
    <Space>
      <Space direction="vertical">
        <Label>
          {taskLabel}
          {' :'}
        </Label>
        <Label>
          {milestoneLabel}
          {' :'}
        </Label>
      </Space>

      <Space direction="vertical">
        <Wrapper>
          <StatusIndicator status={taskTodo} progress={0} />
          <p>{taskTodoLabel}</p>
        </Wrapper>
        <Wrapper>
          <MilestoneTodo />
          <p>{milestoneTodoLabel}</p>
        </Wrapper>
      </Space>

      <Space direction="vertical">
        <Wrapper>
          <StatusIndicator status={taskInProgress} progress={0} />
          <p>{taskInProgressLabel}</p>
        </Wrapper>
        <Wrapper>
          <MilestoneInProgress />
          <p>{milestoneInProgressLabel}</p>
        </Wrapper>
      </Space>

      <Space direction="vertical">
        <Wrapper>
          <StatusIndicator status={taskBlocked} progress={0} />
          <p>{taskBlockedLabel}</p>
        </Wrapper>
        <Wrapper>
          <MilestoneBlocked />
          <p>{milestoneBlockedLabel}</p>
        </Wrapper>
      </Space>

      <Space direction="vertical">
        <Wrapper>
          <StatusIndicator status={taskCompleted} progress={0} />
          <p>{taskCompletedLabel}</p>
        </Wrapper>
        <Wrapper>
          <MilestoneCompleted />
          <p>{milestoneCompletedLabel}</p>
        </Wrapper>
      </Space>
    </Space>
  );
};
